import React, { useState } from "react";
import PropTypes from "prop-types";
import PasswordInput from "../../forms/PasswordInput";
import Button from "../../buttons/Button";
import withStorage from "../../utils/withStorage";
import withRequests from "../../utils/withRequests";
import CoraError from "../../utils/coraError";
/**
 * Password change form component
 * @module

 */
const ChangePasswordForm = (props) => {
  const [state, setState] = useState({
    dataInvalid: false,
    password: {
      value: null,
      isInvalid: false
    },
    matchPassword: {
      value: null,
      isInvalid: false
    }
  });

  const handleChange = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: {
        ...prevState[name],
        value: value,
      },
    }));
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    if(props.changePassword){
      props.changePassword(state.password.value);
      return
    }
    
    try {
      await props.requests.updatePasswordWithCode(props.code, state.password.value, props.expired ?? false)
      props.showMsg("Heslo je úspešne zmenené. Môžte sa prihlásiť.")
      props.reset(props.username)
    }
    catch (error) {
      if (error instanceof CoraError) {
        props.showMsg(error.message, "error")
      }
      else {
        props.showMsg("Neočakávaná chyba.", "error")
      }
    }
  };

  const onBlur = (name, value) => {
    switch (name) {
      case 'password':
        {
          const pattern = props.pattern || "(?=.*[a-zA-Z].*)(?=.*[0-9].*)^[a-zA-Z0-9+*/-]{6,}$";
          setState((prevState) => ({ ...prevState, password: { ...prevState.password, isInvalid: !new RegExp(pattern, "gm").test(prevState.password.value) } }));
          if (state.matchPassword.value) {
            setState((prevState) => ({ ...prevState, matchPassword: { ...prevState.matchPassword, isInvalid: !(value === prevState.matchPassword.value) } }));
          }
          break;
        }
      case 'matchPassword':
        {
          setState((prevState) => ({ ...prevState, matchPassword: { ...prevState.matchPassword, isInvalid: !(prevState.password.value === prevState.matchPassword.value) } }));
          break;
        }
      default: break;
    }
  };

  return (
    <form className="login-form" onSubmit={handleChangePassword}>
      <div className="login-title">Zmeniť heslo</div>
      <div className="login-text">{`${props.expired ? "Heslo expirovalo. " : ""}`}</div>
      <PasswordInput
        label="Nové heslo"
        name="password"
        required={true}
        onChange={handleChange}
        value={state.password.value}
        isInvalid={state.password.isInvalid}
        validationMessage={props.patternText}
        onBlur={onBlur}
      />
      <PasswordInput
        label="Potvrdenie nového hesla"
        name="matchPassword"
        required={true}
        onChange={handleChange}
        value={state.matchPassword.value}
        isInvalid={state.matchPassword.isInvalid}
        validationMessage={'Heslá sa nezhodujú'}
        onBlur={onBlur}
      />
      <Button
        primary={true}
        disabled={((state.password.value === null || state.matchPassword.value === null) || state.password.isInvalid || state.matchPassword.isInvalid)}
        label="Zmeniť heslo"
        type="submit"
      />
      {props.children}
    </form>
  );
}

ChangePasswordForm.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  required: PropTypes.bool,
  validationMessage: PropTypes.string,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  title: PropTypes.string,
};

export default withStorage(withRequests(ChangePasswordForm));